export default __webpack_public_path__ + "static/media/regardBrulant.fb41fa50.png";